import { PatientFeedItem, FindAllOptions } from './models/feedItems';
import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    feedId: string,
    query: FindAllOptions = {},
  ): Promise<PatientFeedItem[]> {
    const url = this.common.constructPath(`feeds/${feedId}/items`, query);
    return this.common.getJSON(url);
  }

  async findAllCounts(
    feedId: string,
    query: FindAllOptions = {},
  ): Promise<{ success: boolean; counts: number }> {
    const url = this.common.constructPath(
      `feeds/${feedId}/items/counts`,
      query,
    );
    return this.common.getJSON(url);
  }
}
